export default __webpack_public_path__ + "static/media/Shower-Pan-IMG_7785.1557a307.jpg";